<template>
    <Field name="third_party" :errors="errors" v-slot="{ error }">
        <div class="card" :class="{ 'border-danger': error }">
            <div class="card-body">
                <b-form-radio-group
                    class="text-lowercase"
                    :checked="currentCheckValue"
                    stacked
                    @change="handleChanged"
                >
                    <b-form-radio class="mb-3" value="register">
                        je m’inscris
                    </b-form-radio>
                    <b-form-radio class="mb-3" value="third_party_with_self">
                        je m’inscris et j’inscris un ou plusieurs autres participants de la même structure
                    </b-form-radio>
                    <b-form-radio value="third_party">
                        je ne participe pas mais j’inscris un ou plusieurs participants de la même structure
                    </b-form-radio>
                </b-form-radio-group>
            </div>
        </div>
    </Field>
</template>

<script>
    import Field from "../../../Field.vue";

    export default {
        components: {
            Field,
        },
        props: {
            value: Object,
            errors: Object,
        },
        computed: {
            currentCheckValue() {
                if(this.value.third_party == null) {
                    return null;
                }
                if(this.value.third_party_with_self) {
                    return 'third_party_with_self'
                }
                if(this.value.third_party) {
                    return 'third_party'
                }
                return 'register';
            },
        },
        methods: {
            handleChanged(value) {
                this.$emit('input', {
                    ...this.value,
                    ...this.nextState(value),
                });
            },
            nextState(value) {
                if(value === 'third_party_with_self') {
                    return {
                        third_party: true,
                        third_party_with_self: true,
                    }
                }
                if(value === 'third_party') {
                    return {
                        third_party: true,
                        third_party_with_self: false,
                    }
                }
                return {
                    third_party: false,
                    third_party_with_self: false,
                }
            },
        },
    }
</script>
